// extracted by mini-css-extract-plugin
export default {"layout":"DataVerificationStatusPopup__layout--2Vw","innerContent":"DataVerificationStatusPopup__innerContent--Bi8","info":"DataVerificationStatusPopup__info--3xB"};